import { useGlobalContext } from "@/hooks/use-global-context";
import { useMemo } from "react";
import { clsxMerge, getFullEntityName } from "shared/lib/helpers";
import { Avatar } from "shared/ui";
import { Field } from "formik";
import { TextArea } from "shared/ui/ae-user-input";

const EnhancedTextArea = TextArea(Field);

export const NotesField = ({
  name,
  errors,
  touched,
  className,
  textAreaClassName,
}: {
  name: string;
  errors?: string;
  touched?: boolean;
  className?: string;
  textAreaClassName?: string;
}) => {
  const { glencocoUser: user } = useGlobalContext();

  const fullUserName = useMemo(() => getFullEntityName(user), [user]);

  return (
    <div className={clsxMerge("w-full", className)}>
      <div className="flex w-full items-center gap-3">
        <Avatar
          className="h-8 w-8"
          placeholderText={fullUserName}
          src={user?.profile_image_url}
        />
        <span className="brand-typography-h7">{fullUserName}</span>
      </div>

      <div className="mt-5 w-full">
        <EnhancedTextArea
          name={name}
          errors={errors}
          touched={touched}
          inputProps={{
            rows: 0,
          }}
          className={textAreaClassName}
          inputClassName={clsxMerge(
            "max-h-[200px] min-h-[50px] w-full bg-white p-0",
            "rounded-none border-none outline-none"
          )}
          placeholder="Add a note for this call"
        />
      </div>
    </div>
  );
};
